import { gql, useMutation } from '@apollo/client'

const mutation = gql`
  mutation updateGroup(
    $id: String!
    $name: String
    $description: String
    $visibility: String
    $mainCategory: String
    $subCategories: [String]
    $profileImageId: String
    $coverImageId: String
  ) {
    updateGroup(
      id: $id
      name: $name
      description: $description
      visibility: $visibility
      mainCategory: $mainCategory
      subCategories: $subCategories
      profileImageId: $profileImageId
      coverImageId: $coverImageId
    ) {
      group {
        id
        name
        description
        visibility
      }
    }
  }
`

export interface UpdateGroupInput {
  id: string
  name?: string
  description?: string
  visibility?: string
  mainCategory?: string
  subCategories?: string[]
  profileImageId?: string
  coverImageId?: string
}

export interface UpdateGroupOutput {
  updateGroup: {
    group: {
      id: string
      name: string
      description: string
      visibility: string
    }
  }
}

export const useUpdateGroup = () => useMutation<UpdateGroupOutput, UpdateGroupInput>(mutation)
